import Model from '@/models/Model'

export default class WhProduct extends Model {
    resource() {
        return 'wh_product'
    }
}